import { defineStore } from "pinia";
import type { UserSessionEntity } from "~/modules/user/models/UserSessionEntity.interface";

/**
 * Store used to save the current organization on operation side
 */
export const useOrganizationStore = defineStore("OrganizationStore", () => {
  const currentOrganization: Ref<UserSessionEntity | undefined> = ref();

  /**
   * Set the current selected organization
   * @param organization
   */
  function setCurrentOrganization(organization?: UserSessionEntity) {
    currentOrganization.value = organization;
  }

  return {
    currentOrganization,
    setCurrentOrganization,
  };
});
